import { $api } from '@service/RequestService';
import { OneLid } from '@utils/models/OneLid';
import { useQuery } from 'react-query';

import { crmConstants } from '..';

export const useLeadId = (props: { id?: number; enabled?: boolean } = { enabled: true }) =>
  useQuery<OneLid>(
    [crmConstants.queryKeys.LEAD_ID, props],
    async () => {
      const res = await $api.get(`/v1/lead/${props?.id}`);

      return res?.data?.data;
    },
    {
      enabled: !!props?.id && props?.enabled
    }
  );
